/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RecordDecisionRequestBody,
  RecordDecisionRequestBody$Outbound,
  RecordDecisionRequestBody$outboundSchema,
} from "../components/recorddecisionrequestbody.js";

export type RecordMcpApprovalDecisionSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type RecordMcpApprovalDecisionSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RecordMcpApprovalDecisionSecurity = {
  option1?: RecordMcpApprovalDecisionSecurityOption1 | undefined;
  option2?: RecordMcpApprovalDecisionSecurityOption2 | undefined;
};

export type RecordMcpApprovalDecisionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  recordDecisionRequestBody: RecordDecisionRequestBody;
};

/** @internal */
export type RecordMcpApprovalDecisionSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const RecordMcpApprovalDecisionSecurityOption1$outboundSchema:
  z.ZodMiniType<
    RecordMcpApprovalDecisionSecurityOption1$Outbound,
    RecordMcpApprovalDecisionSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function recordMcpApprovalDecisionSecurityOption1ToJSON(
  recordMcpApprovalDecisionSecurityOption1:
    RecordMcpApprovalDecisionSecurityOption1,
): string {
  return JSON.stringify(
    RecordMcpApprovalDecisionSecurityOption1$outboundSchema.parse(
      recordMcpApprovalDecisionSecurityOption1,
    ),
  );
}

/** @internal */
export type RecordMcpApprovalDecisionSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RecordMcpApprovalDecisionSecurityOption2$outboundSchema:
  z.ZodMiniType<
    RecordMcpApprovalDecisionSecurityOption2$Outbound,
    RecordMcpApprovalDecisionSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function recordMcpApprovalDecisionSecurityOption2ToJSON(
  recordMcpApprovalDecisionSecurityOption2:
    RecordMcpApprovalDecisionSecurityOption2,
): string {
  return JSON.stringify(
    RecordMcpApprovalDecisionSecurityOption2$outboundSchema.parse(
      recordMcpApprovalDecisionSecurityOption2,
    ),
  );
}

/** @internal */
export type RecordMcpApprovalDecisionSecurity$Outbound = {
  Option1?: RecordMcpApprovalDecisionSecurityOption1$Outbound | undefined;
  Option2?: RecordMcpApprovalDecisionSecurityOption2$Outbound | undefined;
};

/** @internal */
export const RecordMcpApprovalDecisionSecurity$outboundSchema: z.ZodMiniType<
  RecordMcpApprovalDecisionSecurity$Outbound,
  RecordMcpApprovalDecisionSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => RecordMcpApprovalDecisionSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => RecordMcpApprovalDecisionSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function recordMcpApprovalDecisionSecurityToJSON(
  recordMcpApprovalDecisionSecurity: RecordMcpApprovalDecisionSecurity,
): string {
  return JSON.stringify(
    RecordMcpApprovalDecisionSecurity$outboundSchema.parse(
      recordMcpApprovalDecisionSecurity,
    ),
  );
}

/** @internal */
export type RecordMcpApprovalDecisionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  RecordDecisionRequestBody: RecordDecisionRequestBody$Outbound;
};

/** @internal */
export const RecordMcpApprovalDecisionRequest$outboundSchema: z.ZodMiniType<
  RecordMcpApprovalDecisionRequest$Outbound,
  RecordMcpApprovalDecisionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    recordDecisionRequestBody: RecordDecisionRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      recordDecisionRequestBody: "RecordDecisionRequestBody",
    });
  }),
);

export function recordMcpApprovalDecisionRequestToJSON(
  recordMcpApprovalDecisionRequest: RecordMcpApprovalDecisionRequest,
): string {
  return JSON.stringify(
    RecordMcpApprovalDecisionRequest$outboundSchema.parse(
      recordMcpApprovalDecisionRequest,
    ),
  );
}
